import React, { useEffect, useState } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { formatDate } from "../../../../utils/utils";
import { Badge } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { getOutgoingPaymentDocRef } from "../../../../services/finance/outgoingPayment";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";

function SearchOutPaymentDocRef({ onSelectInvoice }) {
  const { reload } = useGlobalData();
  const [invoices, setInvoices] = useState([]);
  useEffect(() => {
    getInvoiceData();
  }, [reload]);

  async function getInvoiceData() {
    const response = await getOutgoingPaymentDocRef();
    const { data } = response.data;
    setInvoices(data.incomingInvoices);
  }

  return (
    <CustomDataTableSearch
      data={invoices}
      onRefreshData={() => {
        getInvoiceData();
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectInvoice(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectInvoice(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "A/P Invoice ID",
          field: "incomingInvoiceCode",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Vendor Name",
          field: "vendor.vendorName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis
                text={rowData.vendor.vendorName}
                maxLine="1"
              />
            </React.Fragment>
          ),
          sortable: true,
          filter: true,
        },
        {
          header: "Invoice Date",
          field: "invoiceDate",
          body: (rowData) => formatDate(rowData.invoiceDate),
          sortable: true,
          filter: true,
        },
        {
          header: "Goods Receive Status",
          field: "grStatusDesc",
          body: (rowData) => {
            if (rowData.grStatus === 1) {
              return <Badge variant="danger">{rowData.grStatusDesc}</Badge>;
            } else if (rowData.grStatus === 2) {
              return <Badge variant="warning">{rowData.grStatusDesc}</Badge>;
            } else if (rowData.grStatus === 3) {
              return <Badge variant="success">{rowData.grStatusDesc}</Badge>;
            } else {
              return <Badge variant="dark">{rowData.grStatusDesc}</Badge>;
            }
          },
          sortable: true,
          filter: true,
        },
        {
          header: "Invoice Status",
          field: "invoiceStatusDesc",
          body: (rowData) => {
            if (rowData.invoiceStatus === 1) {
              return (
                <Badge variant="danger">{rowData.invoiceStatusDesc}</Badge>
              );
            } else if (rowData.invoiceStatus === 2) {
              return (
                <Badge variant="warning">{rowData.invoiceStatusDesc}</Badge>
              );
            } else if (rowData.invoiceStatus === 3) {
              return (
                <Badge variant="success">{rowData.invoiceStatusDesc}</Badge>
              );
            } else {
              return <Badge variant="dark">{rowData.invoiceStatusDesc}</Badge>;
            }
          },
          sortable: true,
          filter: true,
        },
        {
          header: "Payment Status",
          field: "paymentStatus",
          body: (rowData) => {
            if (rowData.paymentStatus === 1) {
              return (
                <Badge variant="danger">{rowData.paymentStatusDesc}</Badge>
              );
            } else if (rowData.paymentStatus === 2) {
              return (
                <Badge variant="warning">{rowData.paymentStatusDesc}</Badge>
              );
            } else if (rowData.paymentStatus === 3) {
              return (
                <Badge variant="success">{rowData.paymentStatusDesc}</Badge>
              );
            } else {
              return <Badge variant="dark">{rowData.paymentStatusDesc}</Badge>;
            }
          },
          sortable: true,
          filter: true,
        },
        {
          header: "Currency",
          field: "currency.currencyCode",
          body: null,
          sortable: true,
          filter: true,
          hidden: true,
        },
        {
          header: "Grand Total",
          field: "grandTotal",
          body: (rowData) => (
            <NumberFormat
              value={rowData.grandTotal}
              displayType={"text"}
              thousandSeparator={true}
              decimalScale={2}
              renderText={(value) => (
                <div className="float-right">
                  {rowData.currency.currencyCode} {value}
                </div>
              )}
            />
          ),
          sortable: true,
          filter: true,
        },
      ]}
    />
  );
}

export default SearchOutPaymentDocRef;
